<template>
  <div
    class="long-form-content"
    data-ui="long-form-content"
  >
    <h2
      v-if="campaignHeading"
    >
      {{ campaignHeading }}
    </h2>
    <div v-html="campaignCopy" />
    <div
      v-if="resourceSections.length"
      class="long-form-content__resources"
    >
      <ResourceSectionComponent
        :resource-sections="resourceSections"
        :graphql-enabled="graphqlEnabled"
        data-ui="resource-section"
      />
    </div>
    <hr>
  </div>
</template>

<script>
import convertToHtml from '@rei/rich-text-renderer';
import ResourceSectionComponent from './ResourceSectionComponent.vue';

export default {
  name: 'LongFormComponent',
  components: {
    ResourceSectionComponent,
  },
  props: {
    longFormContent: {
      type: String,
      default: '',
      required: false,
    },
    heading: {
      type: String,
      default: '',
      required: false,
    },
    resourceSections: {
      type: Array,
      required: false,
      default: () => [],
    },
    graphqlEnabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    campaignCopy() {
      return this.graphqlEnabled ? convertToHtml(this.longFormContent) : this.longFormContent;
    },
    campaignHeading() {
      return this.graphqlEnabled ? this.heading : '';
    },
  },
};
</script>

<style lang="scss">
.long-form-content {
  margin-bottom: $cdr-space-two-x;

  p {
    @include cdr-text-body-300;
  }

  li {
    p {
      margin: 0;
    }
  }

  hr {
    border-top: 1px solid rgba(66, 59, 47, 0.75);
    margin: $cdr-space-two-x 0;

    @include cdr-sm-mq-up {
      display: none;
    }
  }

  @include cdr-sm-mq-up {
    flex: 1 1 0px;
    margin-bottom: 0;
  }

  h2 {
    @include cdr-text-heading-sans-500;
    margin-top: $cdr-space-half-x;
    margin-bottom: $cdr-space-one-x;
  }

  h3 {
    @include cdr-text-utility-sans-400;
  }

  .long-form-content__resources {
    margin-bottom: $cdr-space-two-x;
  }
}
</style>
